import { gql } from '@apollo/client';
import { AiSurveySummaryFragment, ProcessReportFragment, ReportFragment } from './fragments';

export const reportSubscription = gql`
  subscription ReportSubscription(
    $languageCode: String
    $accessToken: String!
    $reportDefinitionId: ID
    $topicGroupId: ID
    $addedOnFrom: Date
    $addedOnTo: Date
    $publicAccess: Boolean
  ) {
    getReport(
      languageCode: $languageCode
      accessToken: $accessToken
      reportDefinitionId: $reportDefinitionId
      topicGroupId: $topicGroupId
      addedOnFrom: $addedOnFrom
      addedOnTo: $addedOnTo
      publicAccess: $publicAccess
    ) {
      ...ReportFragment
    }
  }
  ${ReportFragment}
`;

export const reportSequenceSubscription = gql`
  subscription ReportSequenceSubscription(
    $languageCode: String
    $accessToken: String!
    $addedOnFrom: Date
    $addedOnTo: Date
    $publicAccess: Boolean
    $teamsFilter: [String!]
    $positionIds: [ID!]
    $recruiterIds: [ID!]
    $managerIds: [ID!]
    $withoutDeleted: Boolean
    $showOnlyUnread: Boolean
  ) {
    getProcessReport(
      languageCode: $languageCode
      accessToken: $accessToken
      addedOnFrom: $addedOnFrom
      addedOnTo: $addedOnTo
      publicAccess: $publicAccess
      teamFilters: $teamsFilter
      positionIds: $positionIds
      recruiterIds: $recruiterIds
      managerIds: $managerIds
      withoutDeleted: $withoutDeleted
      showOnlyUnread: $showOnlyUnread
    ) {
      ...ProcessReportFragment
    }
  }
  ${ProcessReportFragment}
`;

export const aiSurveySummarySubscription = gql`
  subscription aiSurveySummarySubscription(
    $languageCode: String!
    $accessToken: String!
    $systemMessage: String
    $answers: [QuestionWithAnswer!]
  ) {
    aiSurveySummary(
      languageCode: $languageCode
      accessToken: $accessToken
      systemMessage: $systemMessage
      answers: $answers
    ) {
      ...AiSurveySummaryFragment
    }
  }
  ${AiSurveySummaryFragment}
`;

export const aiSurveySummaryAbTestSubscription = gql`
  subscription aiSurveySummaryAbTestSubscription(
    $languageCode: String!
    $accessToken: String!
    $defaultSystemMessage: String!
    $answers: [QuestionWithAnswer!]
  ) {
    aiSurveySummaryAbTest(
      languageCode: $languageCode
      accessToken: $accessToken
      defaultSystemMessage: $defaultSystemMessage
      answers: $answers
    ) {
      mode
      experimentId
      layout
      left {
        text
        done
        variantKey
        hash
      }
      right {
        text
        done
        variantKey
        hash
      }
      single {
        text
        done
        hash
      }
    }
  }
`;

export const getProcessKeywordsSubscription = gql`
  subscription getProcessKeywordsSubscription(
    $languageCode: String!
    $accessToken: String!
    $questionIdx: String!
    $answersIds: [String!]!
    $generate: Boolean!
  ) {
    getProcessKeywords(
      languageCode: $languageCode
      accessToken: $accessToken
      questionIdx: $questionIdx
      answersIds: $answersIds
      generate: $generate
    ) {
      keywords {
        label
        commentIds
      }
      done
    }
  }
`;
